import React, { useEffect, useState } from 'react';
import { CONTAINERS } from '../../../constants/columns';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { carsOptions } from '../../../constants/filterOptions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import getContainers from '../../../api/cars/getContainers';

// components
import Header from '../../../components/Header/Header';
import Table from '../../../components/Table/Table';
import TableTabs from '../../../components/TableTabs/TableTabs';
import Empty from '../../../components/Empty/Empty';

// icons
import icon from '../../../brand/generated/sidebar/cars.svg';

const columns = CONTAINERS;

// ÐÐ¾Ð¸ÑÐº Ð¸ ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð¶Ð¸Ð²ÑÑ Ð² Ð°Ð´ÑÐµÑÐµ Ð¸ Ð² sessionStorage. ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ñ Ð¿Ð¾
// Ð¼Ð¾Ð´ÐµÐ»ÑÐ¼ Ð¼Ð°ÑÐºÐ¸, Ð¿ÑÐ°Ð²Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸: Ð¿ÑÐ¾Ð²Ð°Ð»Ð¸Ð»ÑÑ Ð² CHEVROLET Tracker, Ð²ÐµÑÐ½ÑÐ»ÑÑ â
// Ð¸ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ²Ð¸Ð´ÐµÑÑ ÑÐ¾Ñ Ð¶Ðµ ÑÐ¿Ð¸ÑÐ¾Ðº CHEVROLET Ð½Ð° ÑÐ¾Ð¹ Ð¶Ðµ ÑÑÑÐ°Ð½Ð¸ÑÐµ, Ð° Ð½Ðµ Ð¿ÐµÑÐ²ÑÑ
// ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¾Ð±ÑÐµÐ³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°. ÐÐ´ÑÐµÑ Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑ ÐºÐ½Ð¾Ð¿ÐºÑ Â«Ð½Ð°Ð·Ð°Ð´Â» Ð² Ð±ÑÐ°ÑÐ·ÐµÑÐµ,
// sessionStorage â Ð²Ð¾Ð·Ð²ÑÐ°Ñ ÑÐµÑÐµÐ· Ð¼ÐµÐ½Ñ Â«ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»ÑÂ».
const STORAGE_KEY = 'containers.search';

const readStoredSearch = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const storeSearch = (search) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(search));
  } catch {
    // Ð¿ÑÐ¸Ð²Ð°ÑÐ½ÑÐ¹ ÑÐµÐ¶Ð¸Ð¼ â Ð¾Ð±Ð¾Ð¹Ð´ÑÐ¼ÑÑ Ð°Ð´ÑÐµÑÐ¾Ð¼
  }
};

export const restoreSearch = (searchParams) => {
  const fromUrl = searchParams.has('q') || searchParams.has('page');
  const saved = fromUrl
    ? {
        q: searchParams.get('q') ?? '',
        page: Number(searchParams.get('page')),
        pageSize: Number(searchParams.get('pageSize')),
      }
    : readStoredSearch();
  return {
    q: (saved.q ?? '').trim(),
    page: saved.page > 0 ? saved.page : 1,
    pageSize: saved.pageSize > 0 ? saved.pageSize : 10,
  };
};

const CarContainers = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [restored] = useState(() => restoreSearch(searchParams));
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [pagination, setPagination] = useState({
    page: restored.page,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: restored.pageSize,
  });
  const [isFetchAll, setFetchAll] = useState(false);

  const table = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { page, setPageSize } = table;

  const [value, setValue] = useState(restored.q);
  const [queryParams, setQueryParams] = useState(restored.q ? { markAndModel: restored.q } : {});

  // ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº ÑÐ°Ð½ÑÑÐµ ÑÐ¸Ð»ÑÑÑÐ¾Ð²Ð°Ð» ÑÐ¾Ð»ÑÐºÐ¾ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ (10 ÑÑÑÐ¾Ðº), Ð¸
  // Â«KIAÂ» Ð½Ð°ÑÐ¾Ð´Ð¸Ð» Ð² Ð»ÑÑÑÐµÐ¼ ÑÐ»ÑÑÐ°Ðµ Ð¾Ð´Ð¸Ð½-Ð´Ð²Ð° ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ°. Ð¢ÐµÐ¿ÐµÑÑ Ð·Ð°Ð¿ÑÐ¾Ñ ÑÑÐ¾Ð´Ð¸Ñ Ð½Ð°
  // ÑÐµÑÐ²ÐµÑ: Â«KIAÂ» â Ð²ÑÐµ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÑ Ð¼Ð°ÑÐºÐ¸, Â«KIA SportageÂ» â Ð¾Ð´Ð¸Ð½. Ð¢Ð°Ðº Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ
  // Ð¿Ð¾Ð»ÑÑÐ°ÐµÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¼Ð¾Ð´ÐµÐ»ÐµÐ¹ Ð¼Ð°ÑÐºÐ¸ Ð¸ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ñ Ð¿Ð¾ Ð½Ð¸Ð¼, Ð¿ÑÐ°Ð²Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸.
  const searchOnServer = (query) => {
    const markAndModel = (query ?? '').trim();
    setQueryParams(markAndModel ? { markAndModel } : {});
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handleNavigate = () => {
    navigate('/cars/containers/create');
  };

  const goToCard = (index) => {
    navigate('/cars/containers/' + index);
  };

  const init = (page) => {
    setLoading(true);
    getContainers({ ...page })
      .then((res) => {
        setData(res.data.containers);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const search = {
      q: queryParams.markAndModel ?? '',
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    storeSearch(search);
    setSearchParams(
      { ...(search.q ? { q: search.q } : {}), page: String(search.page), pageSize: String(search.pageSize) },
      { replace: true }
    );
    if (!isFetchAll) {
      init({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    }
  }, [pagination.page, pagination.pageSize, queryParams]);

  return (
    <>
      <Header title="ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ" icon={icon} />
      <TableTabs
        setFilter={searchOnServer}
        options={carsOptions}
        value={value}
        setValue={setValue}
        navigate={handleNavigate}
        button={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ'}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð¼Ð°ÑÐºÐ°Ð¼ Ð¸ Ð¼Ð¾Ð´ÐµÐ»ÑÐ¼'}
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <Table
          table={table}
          handleNavigate={goToCard}
          all={'Ð¼Ð°ÑÐ¾Ðº'}
          p={pagination}
          loading={loading}
          pagination
          setPagination={setPagination}
          setFetchAll={setFetchAll}
          isFetchAll={isFetchAll}
          setData={setData}
          setLoading={setLoading}
          queryParams={queryParams}
          api={'/api/shop/getContainers'}
          response={'containers'}
        />
      )}
    </>
  );
};

export default CarContainers;
